/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { useNavigate } from 'react-router-dom';
import Login from './Login';
import './LoginPage.scss';
import AppLink from '../../shared/components/app-link/AppLink';
import { NAVIGATION_ROUTES } from '../../shared/constants/Constants';
import AppButton from '../../shared/components/app-button/AppButton';
import { isEmpty, isMobileWidth } from '../../shared/helper-utils/appUtils';
import AppHidden from '../../shared/components/app-hidden/AppHidden';
import { useAppContext } from '../../saas/AppConfigWrapper';
import {
  getStringFromLS,
  getValueFromAppConfig,
} from '../../shared/helper-utils/localStorage';
import { APP_LOGO_URL } from '../../saas/AppStorageStaticNames';

function LoginPage() {
  const { appConfig } = useAppContext();
  const navigate = useNavigate();
  const handleClick = () => {
    navigate(NAVIGATION_ROUTES.AGENT_REGISTRATION);
  };
  return (
    <div className="login-page d-flex flex-column">
      <div className="login-page_header">
        <div className="login-page_header_container">
          <div className="login-page_header_container_content d-flex justify-content-between align-items-center">
            <div onClick={() => navigate('/')}>
              <img
                src={getStringFromLS(APP_LOGO_URL)}
                alt={appConfig.companyName}
                style={{ maxHeight: `${appConfig.logoHeight}px` }}
              />
            </div>
          </div>
        </div>
      </div>
      <div
        className="align-items-center d-flex flex-1 login-page_content py-2 px-sm-0 px-1"
        style={{
          backgroundImage: `url(${appConfig?.appMainUrl}bannerimg/${appConfig?.appDbName}_indexindex1.jpg)`,
        }}
      >
        <div className="align-items-end d-flex flex-1 justify-content-center justify-content-sm-end max-width">
          <div className="login-container d-flex justify-content-center align-items-center flex-column gap-2">
            <Login />
            <div className="d-flex flex-column gap-2 login-container_registration w-100">
              <div className="login-container_registration_seperator position-relative text-center">
                <span className="fs-14 grey-color position-absolute">or</span>
              </div>
              <AppButton
                btnText="Register with us"
                onClick={handleClick}
                variant="outlined"
              />
            </div>
          </div>
        </div>
      </div>
      <AppHidden smDown>
        <div className="login-page_explore py-3 d-none">
          <div className="login-page_explore_container">
            <div className="login-page_explore_header d-flex flex-sm-row flex-column align-items-sm-center ">
              <div className="login-page_explore_title flex-1 text-sm-start text-center">
                Why {appConfig?.companyName}?
              </div>
              <div className="login-page_explore_sub-title flex-1 text-sm-start text-center">
                {appConfig?.companyName} will help you unlock journeys and
                become your key to limitless travel possibilities.
              </div>
            </div>
            <Row className="login-page_explore_content my-3">
              <Col
                lg={3}
                md={3}
                sm={6}
                xs={12}
                className="d-flex justify-content-center align-items-center"
              >
                <div className="login-page_explore_item">
                  <div className="login-page_explore_item_img">
                    <img src="/images/others/best-ever-rate.png" alt="" />
                  </div>
                  <div className="login-page_explore_item_description">
                    <p>Best Ever Rates</p>
                    <span>
                      Exclusive rates tailored for our partners, ensuring
                      cost-effective solutions
                    </span>
                  </div>
                </div>
              </Col>
              <Col
                lg={3}
                md={3}
                sm={6}
                xs={12}
                className="d-flex justify-content-center align-items-center"
              >
                <div className="login-page_explore_item">
                  <div className="login-page_explore_item_img">
                    <img src="/images/others/express-care.png" alt="" />
                  </div>
                  <div className="login-page_explore_item_description">
                    <p>Express Care</p>
                    <span>
                      Utilize easy-to-use tools for quick query resolutions.
                    </span>
                  </div>
                </div>
              </Col>
              <Col
                lg={3}
                md={3}
                sm={6}
                xs={12}
                className="d-flex justify-content-center align-items-center"
              >
                <div className="login-page_explore_item">
                  <div className="login-page_explore_item_img">
                    <img
                      src="/images/others/confidentiality-assured.png"
                      alt=""
                    />
                  </div>
                  <div className="login-page_explore_item_description">
                    <p>Confidentiality Assured</p>
                    <span>
                      Complete confidentiality of customer details and bookings.
                    </span>
                  </div>
                </div>
              </Col>
              <Col
                lg={3}
                md={3}
                sm={6}
                xs={12}
                className="d-flex justify-content-center align-items-center"
              >
                <div className="login-page_explore_item">
                  <div className="login-page_explore_item_img">
                    <img
                      src="/images/others/cutting-edge-technology.png"
                      alt=""
                    />
                  </div>
                  <div className="login-page_explore_item_description">
                    <p>Cutting-Edge Technology</p>
                    <span>
                      Streamline the booking process to make it user-friendly.
                    </span>
                  </div>
                </div>
              </Col>
            </Row>
            <div className="login-page_explore_banner">
              <img src="/images/others/login-explore-banner.png" alt="" />
            </div>
            <Row className="login-page_advantages my-4">
              <Col lg={6} md={6} sm={12} xs={12}>
                <div className="login-page_advantages_title">
                  Advantages of {appConfig.companyName}
                </div>
              </Col>
              <Col
                lg={6}
                md={6}
                sm={12}
                xs={12}
                className="d-flex flex-column gap-3"
              >
                <div className="login-page_advantages_item d-flex gap-3 align-items-center">
                  <div>
                    <img src="/images/others/Invoice.png" alt="" width={80} />
                  </div>
                  <div className="d-flex flex-column ">
                    <p className="fs-6 mb-1">
                      Effortless Access to Booking and Payment Records
                    </p>
                    <span className="grey-color fs-14 fw-300">
                      Simplify your record-keeping process by easily accessing
                      detailed booking and payment records.
                    </span>
                  </div>
                </div>
                <div className="login-page_advantages_item d-flex gap-3 align-items-center">
                  <div>
                    <img
                      src="/images/others/boarding-pass.png"
                      alt=""
                      width={80}
                    />
                  </div>
                  <div className="d-flex flex-column ">
                    <p className="fs-6 mb-1">
                      Seamless Post-Booking Modifications for Flights
                    </p>
                    <span className="grey-color fs-16">
                      Manage and make modifications to flight bookings with
                      ease, allowing for flexibility and convenience.
                    </span>
                  </div>
                </div>
                <div className="login-page_advantages_item d-flex gap-3 align-items-center">
                  <div>
                    <img src="/images/others/Refund.png" alt="" width={80} />
                  </div>
                  <div className="d-flex flex-column ">
                    <p className="fs-6 mb-1">
                      Straightforward Refund Policy Implementation
                    </p>
                    <span className="grey-color fs-16">
                      Enjoy a simplified refund process, making it easier for
                      you to handle refund requests and provide a seamless
                      experience.
                    </span>
                  </div>
                </div>
                <div className="login-page_advantages_item d-flex gap-3 align-items-center">
                  <div>
                    <img src="/images/others/WhatsApp.png" alt="" width={80} />
                  </div>
                  <div className="d-flex flex-column ">
                    <p className="fs-6 mb-1">
                      Direct Sharing Options on WhatsApp
                    </p>
                    <span className="grey-color fs-16">
                      Share booking details and options directly with your
                      audience on WhatsApp, for efficient communication and
                      customer engagement.
                    </span>
                  </div>
                </div>
                <div className="login-page_advantages_item d-flex gap-3 align-items-center">
                  <div>
                    <img src="/images/others/Ticket.png" alt="" width={80} />
                  </div>
                  <div className="d-flex flex-column ">
                    <p className="fs-6 mb-1">
                      Customised Booking Confirmations with Agency Logo
                    </p>
                    <span className="grey-color fs-16">
                      Enhance your brand presence and professionalism by
                      printing booking confirmations under your agency&apos;s
                      logo.
                    </span>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </AppHidden>
    </div>
  );
}

export default LoginPage;
